import { MessageDto } from './dto';

export enum GroupStatus {
  WAITING = 'WAITING',
  PROCEEDING = 'PROCEEDING',
  CLOSED = 'CLOSED',
}

export const STATUS_TEXT = {
  [GroupStatus.WAITING]: '대기',
  [GroupStatus.CLOSED]: '완료',
  [GroupStatus.PROCEEDING]: '진행',
};

export enum UserType {
  MANAGER = 'MANAGER',
  CLIENT = 'CLIENT',
}

export const USER_TEXT = {
  [UserType.MANAGER]: '매니저',
  [UserType.CLIENT]: '고객',
};

export const ACCEPT_EXTENSIONS = '.jpg, .jpeg, .png, .webp, .pdf';

export interface TempMessage extends MessageDto {
  tempMessageId: number;
}
